// extracted by mini-css-extract-plugin
export default {"titleQuestion":"RegisterAuditorFormStepTen_titleQuestion__4-Nzc","italicTitleQuestion":"RegisterAuditorFormStepTen_italicTitleQuestion__g474e"};